import { MissionKindEnum } from '@e-socna/data-layer';

import { FormVariant } from '../enums/variant.enum';
import { MissionForm } from '../Mission';
import type { MissionCreationFormProps } from '../Mission/types/mission-creation-form-props.type';

export const SimpleMissionCreationForm = ({
  folderConsolidation,
}: Readonly<MissionCreationFormProps>) => (
  <MissionForm
    folderConsolidation={folderConsolidation}
    formVariant={FormVariant.Creation}
    kind={MissionKindEnum.Standard}
    showCancelButton={false}
  />
);
